var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import moment from 'moment';
import { mapState } from 'vuex';
import Treeselect from '@riophae/vue-treeselect';
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import ChartCard from '../../components/ins-claim/chart-card.vue';
import GraphMiniArea from '../../components/ins-claim/graph-mini-area.vue';
import GraphMiniProgress from '../../components/ins-claim/graph-mini-progress.vue';
import GraphMiniBar from '../../components/ins-claim/graph-mini-bar.vue';
export default Vue.extend({
    name: 'el-indicator-overview',
    computed: __assign({}, mapState('vinsurance', [
        'rentCompanyList',
        'insCompanyList',
        'insMainCompanyCodeList',
    ]), { style: function () {
            var ret = {
                paddingLeft: "6px",
                paddingRight: "6px",
                marginBottom: "40px",
            };
            return ret;
        } }),
    props: {
        showPayType: {
            type: Boolean,
            default: false,
        },
        indicators: {
            type: Array,
            default: [],
        },
        callbackFun: {
            type: Function,
            default: null,
        },
        indicatorDefault: {
            type: Object,
            default: {},
        },
    },
    watch: {
        indicatorDefault: function () {
            if (this.indicatorDefault) {
                this.dateArr = this.indicatorDefault.date;
                if (this.indicatorDefault.rentalCompanyList) {
                    this.rentCompanyCode = this.indicatorDefault.rentalCompanyList;
                }
                if (this.indicatorDefault.insCompanyCode) {
                    this.insCompanyCode = this.indicatorDefault.insCompanyCode;
                }
            }
        },
    },
    components: {
        'chart-card': ChartCard,
        'g-mini-area': GraphMiniArea,
        'g-mini-progress': GraphMiniProgress,
        'g-mini-bar': GraphMiniBar,
        'e-tree-select': Treeselect,
    },
    data: function () {
        return {
            loading: false,
            payModel: 0,
            rentCompanyCode: [],
            insCompanyCode: [],
            startTime: '',
            endTime: '',
            dateArr: [],
            defaultPicker: [],
            paymentOptions: [
                {
                    label: '已决金额',
                    value: 0,
                },
                {
                    label: '未决金额',
                    value: 1,
                },
            ],
            pickerOptions: {
                disabledDate: function (time) {
                    return time.getTime() > Date.now();
                },
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick: function (picker) {
                            var today = new Date();
                            var lastWeek = new Date(today.getTime() - 3600 * 1000 * 24 * 6);
                            picker.$emit('pick', [lastWeek, today]);
                        },
                    },
                    {
                        text: '最近一个月',
                        onClick: function (picker) {
                            var today = new Date();
                            var lastMonth = new Date(today.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [lastMonth, today]);
                        },
                    },
                    {
                        text: '最近三个月',
                        onClick: function (picker) {
                            var today = new Date();
                            var lastQuarter = new Date(today.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [lastQuarter, today]);
                        },
                    },
                ],
            },
        };
    },
    methods: {
        getDate: function (val) {
            if (val instanceof Array && val.length > 0) {
                var mt0 = moment(val[0]);
                var mt1 = moment(val[1]);
                if (mt1.diff(mt0, 'days') < 6) {
                    this.$message({
                        showClose: true,
                        message: '时间跨度不能少于7天',
                        type: 'error',
                    });
                    return false;
                }
                this.startTime = moment(val[0]).format('YYYY-MM-DD');
                this.endTime = moment(val[1]).format('YYYY-MM-DD');
            }
            else {
                this.startTime = '';
                this.endTime = '';
            }
            return true;
        },
        transTreeSelect: function (selectOptions) {
            var _this = this;
            var insCompanyCodeList = [];
            var insCompanyCodeSecondList = [];
            if (selectOptions && selectOptions.length > 0) {
                // 分组母公司、子公司
                selectOptions.forEach(function (option) {
                    if (_this.insMainCompanyCodeList.indexOf(option) >= 0) {
                        insCompanyCodeList.push(option);
                    }
                    else {
                        insCompanyCodeSecondList.push(option);
                    }
                });
            }
            return {
                insCompanyCodeList: insCompanyCodeList,
                insCompanyCodeSecondList: insCompanyCodeSecondList,
            };
        },
        updateOtherParams: function () {
            var ret = this.getDate(this.dateArr);
            if (!ret) {
                return;
            }
            var _a = this, startTime = _a.startTime, endTime = _a.endTime, insCompanyCode = _a.insCompanyCode, rentCompanyCode = _a.rentCompanyCode, dateArr = _a.dateArr, payModel = _a.payModel;
            var insCompanySelections = this.transTreeSelect(insCompanyCode);
            var searchParam = __assign({}, insCompanySelections, { rentalCompanyList: rentCompanyCode, queryStartTime: startTime, queryEndTime: endTime, insCompanyCode: insCompanyCode, date: dateArr, payModel: payModel });
            if (this.callbackFun) {
                this.callbackFun(searchParam);
            }
        },
    },
    mounted: function () { },
});
